import Modal from '../../components/modal.js';

var UserSessionModal = Modal.extend({
  dom: {
    NOOP_TEXT: '#user-session-modal__noop',
    NOOP_LINK: '#noop-link',
    EXPIRED_TEXT: '#user-session-modal__expired',
    SESSION_COUNTDOWN: '#user-session-countdown',
  },

  events: function () {
    var events = {};

    events['click ' + this.dom.NOOP_LINK] = '_noopLinkClicked';
    return events;
  },

  startListening() {
    this.listening = true;
    $(document).on('keydown', (e) => {
      if (e.keyCode == 9 && this.opened) {
        e.preventDefault();
      }
    });
  },

  show: function (position) {
    var self = this;

    this.sessionRemaingTime = undefined;
    this.opened = true;

    if (!this.listening) {
      this.startListening();
    }

    this._showBackground();
    this._setPosition(position || this.opts.position);
    this.waiting(false);

    self.$el.css({ display: 'block' });

    setTimeout(function () {
      self.$el.addClass('modal-fade-in');

      setTimeout(self._afterShow.bind(self), 100);
    }, 100);

    return this;
  },

  close: function () {
    this.$el.removeClass('modal-fade-in');
    this.$background.removeClass('modal-fade-in');

    this.opened = false;
    this.trigger('modalClosed');
    this._afterClose();

    return this;
  },

  _afterShow: function () {
    var self = this,
      remainingTime;

    $('input:focus').trigger('blur');

    window.sessionRemaingTime = window.setInterval(function () {
      var currentExpiration = parseInt(
        window.localStorage.getItem('user-session'),
      );

      if (
        isNaN(currentExpiration) ||
        parseInt(Date.now()) > currentExpiration
      ) {
        self._showExpiredMessage();
      } else {
        remainingTime = Math.floor((currentExpiration - Date.now()) / 1000);

        if (remainingTime > 0) {
          $(self.dom.SESSION_COUNTDOWN).text(remainingTime);
        } else {
          window.clearInterval(window.sessionRemaingTime);
          self._showExpiredMessage();
        }
      }
    }, 1000);
  },

  _afterClose: function () {
    $('.modal-background').css({ zIndex: 100 });
  },

  onRefresh: function (callback) {
    this.refreshCallback = callback;
  },

  onSessionExpired: function (callback) {
    this.onSessionExpiredCallback = callback;
  },

  refreshSession: function (callback) {
    var self = this;

    $.ajax({
      url: '/noop',
    })
      .done(function () {
        callback();
      })
      .fail(function () {
        self._showExpiredMessage();
      });
  },

  _noopLinkClicked: function (e) {
    e.preventDefault();

    if (this.refreshCallback) {
      this.refreshSession(this.refreshCallback);
    }
  },

  _showExpiredMessage: function () {
    var self = this;

    window.clearInterval(window.sessionRemaingTime);

    if (typeof this.onSessionExpiredCallback !== 'undefined') {
      this.onSessionExpiredCallback();
    }

    $(this.dom.NOOP_TEXT).fadeOut(150, function () {
      $(self.dom.EXPIRED_TEXT).fadeIn(150);

      self.$el.animate(
        {
          height: 170,
        },
        150,
      );
    });
  },
});

module.exports = UserSessionModal;
